export type ConnectionFilterSelection = string[] | null;

export const getNextConnectionFilterSelection = (
  previousSelection: ConnectionFilterSelection,
  clickedConnectionId: string,
  allConnectionFilterIds: string[],
): ConnectionFilterSelection => {
  const normalizedPreviousSelection =
    previousSelection === null
      ? allConnectionFilterIds
      : previousSelection.filter((id) => allConnectionFilterIds.includes(id));

  const isEffectivelyAllSelected =
    normalizedPreviousSelection.length === allConnectionFilterIds.length;

  if (isEffectivelyAllSelected) {
    return [clickedConnectionId];
  }

  const currentSelection = new Set(normalizedPreviousSelection);

  if (!currentSelection.has(clickedConnectionId)) {
    currentSelection.add(clickedConnectionId);
    return [...currentSelection];
  }

  currentSelection.delete(clickedConnectionId);
  if (currentSelection.size === 0) {
    return null;
  }

  return [...currentSelection];
};
